import equal from 'fast-deep-equal';
import { Notation, NotationType } from '@alucio/aws-beacon-amplify/src/models';
import type { ContentType, LoadedPresentation } from './ContentProvider';
import { getBookmarkedPageIds, getBookmarkedPages } from 'src/utils/pageBookmarkHelpers';
import { getVisiblePresentationPages } from 'src/utils/hiddenSlides';

export type PageNavigationView = 'all' | 'bookmarks';

export function getBookmarkArrowTargets(
  presentation: LoadedPresentation, skipHiddenSlides: boolean, contentPages?: ContentType['contentPageData'],
) {
  if (presentation.pageNavigationView !== 'bookmarks') return undefined;

  const { presentable, currentPresentablePage } = presentation;
  const pages = skipHiddenSlides
    ? getVisiblePresentationPages({ pages: presentable.presentablePages, contentPages })
    : presentable.presentablePages;
  const current = currentPresentablePage.presentationPageNumber;
  let previous: number | undefined;
  let next: number | undefined;

  for (const { presentationPageNumber: number } of getBookmarkedPages(pages, presentable.notations ?? [])) {
    if (number < current && (previous === undefined || number > previous)) previous = number;
    if (number > current && (next === undefined || number < next)) next = number;
  }

  return { previous, next };
}

export function setPresentationPageView(
  presentation: LoadedPresentation, view: PageNavigationView,
): LoadedPresentation {
  return { ...presentation, pageNavigationView: view };
}

export function refreshPresentationBookmarks(
  presentation: LoadedPresentation, source: readonly Notation[],
): LoadedPresentation {
  const bookmarks = source.filter(n => n.type === NotationType.PAGE_BOOKMARK);
  const notations = [
    ...presentation.presentable.notations?.filter(n => n.type !== NotationType.PAGE_BOOKMARK) ?? [], ...bookmarks,
  ];
  const pageNavigationView = getBookmarkedPageIds(bookmarks).length ? presentation.pageNavigationView : 'all';
  if (equal(notations, presentation.presentable.notations) && pageNavigationView === presentation.pageNavigationView) {
    return presentation;
  }
  return { ...presentation, pageNavigationView, presentable: { ...presentation.presentable, notations } };
}
